// removed by extract-text-webpack-plugin
module.exports = {"CalcWarningWrapper":"CalcWarning__-loca-__Cg3az","CalcWarningHelper":"CalcWarning__-loca-__Z0wTB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/CalcWarning/CalcWarning.css
// module id = 207
// module chunks = 0